import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ai-sourcing-profile-skeleton',
    templateUrl: './ai-sourcing-profile-skeleton.component.html',
    styleUrls: ['./ai-sourcing-profile-skeleton.component.scss'],
    standalone: false
})
export class AiSourcingProfileSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
